import { SearchTab } from "@habity/types";

/*
 * @deprecated
 * Indices and names are no longer coupled
 */
export const getTabIndexFromName = (name?: SearchTab) => {
  switch (name) {
    case "homes":
      return 0;
    case "speculators":
      return 1;
    case "brokers":
      return 2;
    case "areas":
      return 3;
    case "municipalities":
      return 4;
    case "places":
      return 5;
    case "projects":
      return 6;
    default:
      return 0;
  }
};

/*
 * @deprecated
 * Indices and names are no longer coupled
 */
export const getTabNameFromIndex = (index?: number): SearchTab => {
  switch (index) {
    case 0:
      return "homes";
    case 1:
      return "speculators";
    case 2:
      return "brokers";
    case 3:
      return "areas";
    case 4:
      return "municipalities";
    case 5:
      return "places";
    case 6:
      return "projects";
    default:
      return "homes";
  }
};

export const getTabLabelFromName = (name?: SearchTab) => {
  switch (name) {
    case "homes":
      return "Bostäder";
    case "speculators":
      return "Spekulanter";
    case "brokers":
      return "Mäklare";
    case "areas":
      return "Områden";
    case "municipalities":
      return "Områden";
    case "places":
      return "Kontor";
    case "projects":
      return "Nyproduktion";
    default:
      return "Bostäder";
  }
};

export const getTabNameFromUrlPath = (path?: string | null): SearchTab => {
  const searchTabs: SearchTab[] = [
    "homes",
    "speculators",
    "brokers",
    "areas",
    'municipalities',
    'places',
    'projects'
  ];
  const tabName = (path?.split("/")[1] as SearchTab) || "homes";
  return searchTabs.includes(tabName) ? tabName : "homes";
};
